/** @jsxImportSource @emotion/react */
import { TextFields, Widgets } from '@zip/business-components';
import { Divider } from 'components';
import { FC } from 'react';
import * as styles from './CustomiseOffers.styles';
import { CustomiseOffersOptionPropsExtend } from './CustomiseOffersOptionProps';

const CustomiseOffersCheckbox: FC<CustomiseOffersOptionPropsExtend> = ({
  id,
  title,
  subCopy,
  details,
  disabled,
  formik,
}) => {
  const index =
    formik.values.offers?.findIndex((offer: any) => offer.id === id) ?? -1;

  if (index === -1) {
    return <></>;
  }

  const handleCheckboxChange = (
    e: React.ChangeEvent<unknown>,
    checked: boolean
  ): void => {
    // Update the specific offer in the array
    formik.setFieldValue(`offers[${index}].selected`, checked, true);
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    formik.setFieldValue(`offers[${index}].details`, e.target.value);
  };

  // Access values from the array structure
  const isChecked = formik.values.offers?.[index]?.selected || false;
  const textValue = formik.values.offers?.[index]?.details || '';

  // Access errors from the array structure
  const detailsTouched = formik.touched.offers?.[index]?.details;
  const detailsErrors = formik.errors.offers?.[index]?.details;
  const hasTextError = detailsTouched && Boolean(detailsErrors);
  const textErrorMessage = detailsTouched && detailsErrors;

  return (
    <div css={styles.checkboxItem}>
      <Divider css={styles.divider} />
      <section key={id} css={styles.checkboxGroup}>
        <div css={styles.checkboxAndLabel}>
          <Widgets.Checkbox
            disabled={disabled}
            name={`offers[${index}].selected`}
            label={
              <div css={styles.checkboxLabel}>
                <div className="body2" css={styles.headingStyle(isChecked)}>
                  {title}
                </div>
                <span className="body3" css={styles.subCopy}>
                  {subCopy}
                </span>
              </div>
            }
            checked={isChecked}
            onChange={handleCheckboxChange}
            css={styles.checkbox}
          />
        </div>
        {isChecked && (
          <div css={styles.details}>
            <TextFields.Outlined
              type="text"
              disabled={disabled}
              name={`offers[${index}].details`}
              onChange={handleTextChange}
              onBlur={formik.handleBlur}
              value={textValue}
              error={hasTextError}
              helperText={textErrorMessage}
              label={details.label}
              css={styles.textArea}
              minRows={1}
              maxRows={10}
              multiline
              fullWidth
            />
          </div>
        )}
      </section>
    </div>
  );
};

export default CustomiseOffersCheckbox;
